<div class="model__container">
    <mat-dialog-content>
        <div>
            <div class="model-popup-main-outr">
                <div class="delete-subimg-outer">
                    <img src="assets/images/warning-sub-ico.svg" class="delete-subimg">
                </div>
                <div class="delete-subimg-outer-rght">
                    <div class="popup-right-head ">{{headerMessage}}</div>
                    @if(isStringMessage()){
                    <div class="popup-right-txt">{{stringMessage}}</div>
                    } @else if (isStructuredMessage()) {
                    <div class="popup-right-txt">
                        <p [innerHTML]="formatPopupText(structuredMessage?.intro || '')"></p>
                        @for (section of structuredMessage?.sections ?? []; track section.title) {
                        <p class="title"><strong [innerHTML]="formatPopupText(section.title)"></strong></p>
                        <ul class="missed-list">
                            @for (item of section.items; track item) {
                            <li><span [innerHTML]="formatPopupText(item)"></span></li>
                            }
                        </ul>
                        }
                        @if (structuredFooterLines.length > 0) {
                        <div class="popup-footer-lines">
                        @for (line of structuredFooterLines; track $index) {
                        <p [innerHTML]="formatPopupText(line)"></p>
                        }
                        </div>
                        }
                    </div>
                    } @else {
                    <div class="popup-right-txt">
                        <ul>
                            <li *ngFor="let msg of listMessage">{{msg}}</li>
                        </ul>
                    </div>
                    }
                </div>
            </div>
            <div class=" ">
                <div class="buttons-fotr-new">
                    <app-button id="submitBtn" (click)="onSubmitClick()" label="Ok" [isFilled]="false"></app-button>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>